import { createContext } from "react"

export type WebSocketStatusType = "connected" | "disconnected" | "reconnecting"

export const WebSocketStatusContext = createContext<WebSocketStatusType>("connected")